import { apiCall } from "../../../services/api-service.js";

const get = (endpoint, params) => apiCall("get", endpoint, null, { params });
const post = (endpoint, body) => apiCall("post", endpoint, body);
const put = (endpoint, body) => apiCall("put", endpoint, body);
const del = (endpoint, data = null) => apiCall("delete", endpoint, data);

export const getPaymentTypeListApi = async (params) => {
  try {
    return await get("payment_type", params);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};


export const submitPaymentTypeApi = async (body) => {
  try {
    return await post("payment_type", body);
  } catch (err) {
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};


export const updatePaymentTypeListApi = async (id, body) => {
  try {
    return await put(`payment_type/${id}`, body);
  } catch (err) {
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const bulkDeletePaymentTypeApi = async (payload) => {
  try {
    const data = Array.isArray(payload) ? { id: payload } : payload;
    return await del("payment_type/bulk_delete", data);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const deletePaymentTypeListApi = async (id) => {
  try {
    return await del(`payment_type/delete/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const getPaymentTypeByIdApi = async (id) => {
  try {
    return await get(`payment_type/edit/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};